import moment from "moment";
import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";
import { Dropdown } from "react-bootstrap";
import { Helmet } from "react-helmet";
import _enum from "src/mixins/enum";
import ReportSearch from "./ReportSearch";
import { addDays } from "date-fns";

const months = Object.entries([
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
]).map(([key, value]) => ({ key, value }));

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      schoolIdStateLS: localStorage.getItem("school_id"),
      dashboardData: [],
      invoiceData: [],
      rowcount: 0,
      search: {
        limit: 5,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      eventSearch: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      series: [],
      options: {},
      series2: [],
      options2: {},
      searchFields: {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
        // start_date: new Date().toISOString(),
        // end_date: addDays(new Date(), 7).toISOString(),
        school_id: null,
        curriculum_id: null,
      },
      fields: [
        {
          name: "month",
          type: "month",
          label: "Month & Year",
          className: "status-dropdown",
          placeholder: "Month",
          onChange: (event) => {
            console.log("EVENT:", event);

            let d = new Date(event.split(",")[0]);
            if (d) {
              this.setState(
                {
                  searchFields: {
                    ...this.state.searchFields,
                    month: d.getMonth(),
                    year: d.getFullYear(),
                  },
                },
                () => {
                  console.log("FALLBACK");

                  this.fetchMonthlyEventProgress();
                }
              );
            }
          },
          defaultValue: `${
            months.find(({ key }, i) => parseInt(key) === new Date().getMonth())
              .value
          }-${new Date().getFullYear()}`,
        },
        {
          name: "daterange",
          type: "daterange",
          label: "Start & End Date",
          placeholder: "Start & End Date",
          autoEndOffsetDays: "7",
          maxSelectableDays: "7",
          outerColclass: "col-sm-6 col-md-4 col-xl-4 col-xxl-3 d-none",
          defaultStartDate: new Date(),
          defaultEndDate: addDays(new Date(), 7),
          onChange: (event) => {
            console.log(event);
            if (event) {
              this.setState(
                {
                  searchFields: {
                    ...this.state.searchFields,
                    start_date: this.toUTCISOStringMidnight(event?.startDate),
                    end_date: this.toUTCISOStringMidnight(event?.endDate),
                  },
                },
                () => {
                  console.log("FALLBACK");
                  this.fetchMonthlyEventProgress();
                }
              );
            }
          },
        },
        {
          type: "select",
          options: [],
          onChange: (val) => {
            let hasKey = val.length === 0 || val[0]?.key === "" ? false : true;
            if (hasKey) this.handleSchoolClassModuleChange(val, "school_id");
            console.log(val, hasKey);
          },
          name: "school_id",
          label: "School",
          placeholder: "All",
          outerColclass: "mw-250",
        },
        {
          type: "select",
          options: [],
          onChange: (val) => {
            let hasKey = val.length === 0 || val[0]?.key === "" ? false : true;
            if (hasKey)
              this.handleSchoolClassModuleChange(val, "curriculum_id");
            console.log(val, hasKey);
          },
          name: "curriculum_id",
          label: "Class",
          placeholder: "All",
        },
        {
          type: "select",
          options: [],
          onChange: (val) => {
            let hasKey = val.length === 0 || val[0]?.key === "" ? false : true;
            if (hasKey) this.handleSchoolClassModuleChange(val, "section");
            console.log(val, hasKey);
          },
          name: "section",
          label: "Section",
          placeholder: "All",
        },
      ],
      reportData: [],
      reportRowcount: 0,
      schooldata: [],
      graphReportType: "MONTHLY",
      selectionRange: {
        start_date: new Date(),
        end_date: new Date(),
        key: "selection",
      },
    };
    this.reportColumns = [
      {
        dataIndex: "row",
        title: "Row #",
        render: (text, record, i) => {
          return <>{i + 1}</>;
        },
      },
      { dataIndex: "school_name", title: "School" },
      {
        dataIndex: "grade",
        title: "Grade",
        render: (text, record, i) => {
          return <>{record?.curriculum[0]?.curriculum_name || "-"}</>;
        },
      },
      {
        dataIndex: "section",
        title: "Section",
        render: (text, record, i) => {
          return <>{record?.section?.name || "-"}</>;
        },
      },
      {
        dataIndex: "session",
        title: "Session (Topic)",
        render: (text, record, i) => {
          return <>{record?.session?.session_name || "-"}</>;
        },
      },
      {
        dataIndex: "converted_event_date",
        title: "Date",
        render: (text, record) => {
          let date = new Date(text).dateToDDMMYYYY(new Date(text));
          return date;
        },
      },
      {
        dataIndex: "event_status",
        title: "Status",
        render: (text, record) => {
          return (
            <span
              className={`badge light border-0 ${
                text === "Cancelled" ? "text-danger" : "badge-success"
              } `}
            >
              {text === "OPEN" ? "Scheduled" : text?.toTitleCase()}
            </span>
          );
        },
      },
      { dataIndex: "attendance_count", title: "Attendance" },
    ];
  }

  checkAndFetchForCoordinator = () => {
    let schoolId = localStorage.getItem("school_id");
    if (schoolId && schoolId !== "null" && schoolId !== "undefined") {
      this.setState({ loader: false }, () => {
        this.fetchEventDashboardStats();
      });
    } else {
      if (!this.state.loader) {
        this.setState({ loader: true });
      }
      setTimeout(this.checkAndFetchForCoordinator, 500);
    }
  };

  componentDidMount() {
    // Store previous school ID from localStorage or Redux
    this.prevSchoolId = localStorage.getItem("school_id");

    // Listen to store updates
    this.unsubscribe = window.store.subscribe(this.handleStoreChange);

    if (localStorage.getItem("currentAdminRole") === "SUPER_ADMIN") {
      this.fetchDashboardStats();
      this.fetchEventDashboardStats();

      this.getSchoolNames();
      this.fetchMonthlyEventProgress();
    }
    if (localStorage.getItem("currentAdminRole") === "SCHOOL_ADMIN") {
      this.fetchEventDashboardStats();
    }
    if (localStorage.getItem("currentAdminRole") === "SCHOOL_COORDINATOR") {
      this.checkAndFetchForCoordinator();
    }

    if (document.querySelector('.graph_chart [name="appinput-daterange"]')) {
      document
        .querySelector('.graph_chart [name="appinput-daterange"]')
        .parentElement?.classList?.add("d-none");
    }
  }

  componentWillUnmount() {
    // Clean up the store listener
    if (this.unsubscribe) this.unsubscribe();
  }

  handleStoreChange = () => {
    const currentSchoolId = window.store.getState().root.coordschool;
    const currentRole = localStorage.getItem("currentAdminRole");

    // Check for role and school ID change
    if (
      currentRole === "SCHOOL_COORDINATOR" &&
      currentSchoolId &&
      currentSchoolId !== this.prevSchoolId &&
      sessionStorage.getItem("schoolReloaded") !== "true"
    ) {
      // Update localStorage to new school
      localStorage.setItem("school_id", currentSchoolId);
      sessionStorage.setItem("schoolReloaded", "true");

      // Trigger reload
      location.reload();
    }

    // Reset reload flag if the IDs match again
    if (currentSchoolId === localStorage.getItem("school_id")) {
      sessionStorage.setItem("schoolReloaded", "false");
    }
  };

  onNext() {}

  onPrev() {}

  onPageChange(pageData) {
    this.setState({
      search: {
        ...this.state.search,
        page: pageData.current,
        limit: pageData.pageSize || pageData.defaultPageSize || 25,
      },
    });
  }

  transformData(classesData) {
    console.log({ classesData });
    const transformedData = [];
    const modules = ["Conceptual", "Personality", "Engineering & Technology"];
    const moduleMap = new Map(modules.map((key) => [key, []]));

    classesData.forEach((classItem, i) => {
      modules.forEach((moduleItem) => {
        let module = classItem.modules.find(
          (mod) => mod.module_name === moduleItem
        );
        moduleMap.get(moduleItem).push(module?.progress || 0);
      });
    });

    moduleMap.forEach((progressArray, moduleName) => {
      transformedData.push({
        name: moduleName,
        data: progressArray,
      });
    });
    return transformedData;
  }

  fetchDashboardStats() {
    let schoolId = localStorage.getItem("school_id");
    this.props.api
      .apiDashboardData({ school_id: schoolId })
      .then(({ data }) => {
        let op = [];
        if (localStorage.getItem("currentAdminRole") === "SCHOOL_ADMIN") {
          op = [
            {
              formName: "Total Class",
              count: data?.classCount,
              icon: imagepaths.dashboardClassIcon,
            },

            {
              formName: "Total Students",
              count: data?.studentCount,
              icon: imagepaths.dashboardStudent,
            },
            {
              formName: "Total Modules",
              count: data?.moduleCount,
              icon: imagepaths.dashboardModules,
            },
            {
              formName: "Total Session",
              count: data?.sessionCount,
              icon: imagepaths.dashboardSession,
            },
          ];
          let invoiceData = [
            {
              formName: "Total Invoice",
              count: data?.totalInvoice,
              icon: imagepaths.InvoiceDashboardIcon,
            },

            {
              formName: "Paid Invoice",
              count: data?.paidInvoice,
              icon: imagepaths.InvoicePaid,
            },
            {
              formName: "Last paid on",
              count: moment
                .utc(data?.lastPaidInvoice?.updatedAt)
                ?.format("DD/MM/YYYY"),
              icon: imagepaths.InvoiceCalender,
            },
            {
              formName: "Last paid Amount",
              count: data?.lastPaidInvoice?.invoice_amount,
              icon: imagepaths.InvoicePaidAmount,
            },
          ];
          this.setState({
            invoiceData: invoiceData,
            dashboardData: op,
          });
        } else {
          op = [
            {
              formName: "Active Schools",
              count: data?.schoolsCount,
              icon: imagepaths.dashboardSchoolsIcon,
            },
            {
              formName: "Total Classes",
              count: data?.classCount,
              icon: imagepaths.dashboardClassIcon,
            },
            {
              formName: "Total Sections",
              count: data?.sectionCount,
              icon: imagepaths.dashboardSectionsIcon,
            },
            {
              formName: "Enrolled Students",
              count: data?.studentCount,
              icon: imagepaths.dashboardStudentsIcon,
            },
          ];

          this.setState({
            dashboardData: op,
          });
        }
      });
  }
  fetchEventDashboardStats(params) {
    console.log({ params });

    let schoolId = localStorage.getItem("school_id");

    let payload = {
      ...params,
      ...(schoolId !== "null"
        ? {
            school_id: schoolId,
          }
        : {}),
      ...(params?.start_date
        ? {
            start_date: new Date(params?.start_date).toISOString(),
          }
        : {}),
      ...(params?.end_date
        ? {
            end_date: new Date(params?.end_date).toISOString(),
          }
        : {}),
    };
    console.log({ payload });

    this.props.api.apiEventDashboardData(payload).then(({ data, total }) => {
      // console.log("EVENT DASHBOARD DATA:", data, total);
      this.setState({
        reportData: data,
        reportRowcount: total,
      });
    });
  }

  fetchDashboardBarChart() {
    let schoolId = localStorage.getItem("school_id");
    this.props.api
      .apiGetDashboardBarChartData({ school_id: schoolId })
      .then(({ data }) => {
        if (data?.length > 0) {
          this.setState({
            series: this.transformData(data),
            options: {
              chart: {
                type: "bar",
                height: 650,
              },
              stroke: {
                width: 1,
                colors: ["#fff"],
              },
              dataLabels: {
                formatter: (val) => {
                  return val?.toFixed(2) + "%";
                },
              },
              plotOptions: {
                bar: {
                  columnWidth: "50px",
                },
              },
              xaxis: {
                categories: data.map(
                  (item) => item?.curriculum_details?.curriculum_grade
                ),
                labels: {
                  formatter: (val) => {
                    return "Class " + val;
                  },
                },
                title: {
                  text: "Classes",
                  style: {
                    fontSize: "12px",
                    fontWeight: "600px",
                    fontFamily: "Lexend",
                    color: "#8F8787",
                  },
                },
                axisBorder: {
                  show: true,
                  color: "#000000",
                },
              },
              yaxis: {
                title: {
                  text: "Completion %",
                  style: {
                    fontSize: "12px",
                    fontWeight: "600px",
                    fontFamily: "Lexend",
                    color: "#8F8787",
                    marginBottom: "10px",
                  },
                },
                axisBorder: {
                  show: true,
                  color: "#000000",
                },
                labels: {
                  formatter: (val) => {
                    return val?.toFixed(2) + "%";
                  },
                },
              },
              fill: {
                opacity: 1,
              },
              colors: ["#FBA106", "#111C3A", "#FFCB71"],
              legend: {
                position: "bottom",
                horizontalAlign: "center",
                itemMargin: {
                  horizontal: 10,
                  vertical: 5,
                },
              },
            },
          });
        }
      });
  }

  fetchSessionProgressBarChart() {
    this.props.api
      .apiGetSessionProgressBarChart({
        month: this.state.searchFields.month,
        year: this.state.searchFields.year,
        school_id: this.state.searchFields.school_id,
        curriculum_id: this.state.searchFields.curriculum_id,
      })
      .then(({ data }) => {
        this.setState({
          series2: [
            {
              name: "Sessions",
              data: data?.map((item) => item.count) || [],
            },
          ],
          options2: {
            chart: {
              type: "bar",
              height: 650,
            },
            stroke: {
              width: 1,
              colors: ["#fff"],
            },
            dataLabels: {
              formatter: (val) => {
                return val;
              },
            },
            plotOptions: {
              bar: {
                columnWidth: "50px",
              },
            },
            xaxis: {
              categories: data.map((item) => item?.monthWeekNumber) || [],
              labels: {
                formatter: (val) => {
                  return "Week " + val;
                },
              },
              title: {
                text: "Weeks",
                style: {
                  fontSize: "12px",
                  fontWeight: "600px",
                  fontFamily: "Lexend",
                  color: "#8F8787",
                },
              },
              axisBorder: {
                show: true,
                color: "#000000",
              },
            },
            yaxis: {
              title: {
                text: "Number of Completed Sessions",
                style: {
                  fontSize: "12px",
                  fontWeight: "600px",
                  fontFamily: "Lexend",
                  color: "#8F8787",
                  marginBottom: "10px",
                },
              },
              axisBorder: {
                show: true,
                color: "#000000",
              },
              labels: {
                formatter: (val) => {
                  return val;
                },
              },
            },
            fill: {
              opacity: 1,
            },
            colors: ["#FFCB71"],
            legend: {
              position: "bottom",
              horizontalAlign: "center",
              itemMargin: {
                horizontal: 10,
                vertical: 5,
              },
            },
          },
        });
      });
  }

  fetchMonthlyEventProgress(params, reset = false) {
    this.setState({
      loader: true,
    });
    console.log(this.state.searchFields, this.state.graphReportType);

    let payload = {
      month: this.state.searchFields.month + 1,
      year: this.state.searchFields.year,
      school_id: this.state.searchFields.school_id,
      curriculum_id: this.state.searchFields.curriculum_id,
      section_id: this.state.searchFields.section,
      type: this.state.graphReportType,
      ...(this.state.graphReportType === "WEEKLY" &&
      this.state.searchFields.start_date
        ? {
            start_date: this.state.searchFields.start_date,
          }
        : { start_date: "" }),
      ...(this.state.graphReportType === "WEEKLY" &&
      this.state.searchFields.end_date
        ? {
            end_date: this.state.searchFields.end_date,
          }
        : { end_date: "" }),
    };
    console.log({ payload });

    this.props.api
      .apiGetMonthlyEventProgress(
        reset
          ? {
              month: new Date().getMonth() + 1,
              year: new Date().getFullYear(),
              type: "MONTHLY",
              school_id: "",
              curriculum_id: "",
              section_id: "",
            }
          : payload
      )
      .then(({ data }) => {
        console.log({ graphdata: data });

        const isWeekly = data[0]?.week !== undefined;
        const isDaily = data[0]?.date !== undefined;

        const categories = data.map((entry) => {
          return isWeekly ? `Week ${entry.week}` : entry.date;
        });

        const series = _enum.EVENT_STATUS.map((status) => {
          return {
            name: status.label,
            data: data.map((entry) => {
              const statusesArray = entry.statuses || entry.status || [];
              const matchedStatus = statusesArray.find(
                (s) => s.status === status.key
              );
              return matchedStatus ? matchedStatus.count : 0;
            }),
          };
        });

        const options = {
          chart: {
            type: "bar",
            height: 450,
            stacked: false,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "35px",
            },
          },
          colors: ["#E2E3E3", "#F4D3CC", "#ECFDF5"],
          xaxis: {
            categories: categories,
          },
          yaxis: {
            title: {
              text: "Number of Events",
            },
          },
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["#B5B5B5", "#F53D15", "#64C391"],
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ["#B5B5B5", "#F53D15", "#64C391"],
              fontWeight: "bold",
            },
          },
        };
        this.setState({
          series3: series,
          options3: options,
          loader: false,
        });
      })
      .catch((error) => {
        this.setState({
          loader: false,
        });
      });
  }

  getSchoolNames = () => {
    this.props.api
      .apiGetAllSchoolListSuperAdmin()
      .then(({ data, total }) => {
        let schoolNames = this.state.fields.find((o) => o.name == "school_id");
        schoolNames.options = [
          { key: "", label: "All" },
          ...data?.options("school_id", "school_name"),
        ];
        this.setState({
          ...this.state.fields,
          schooldata: [...data],
        });
      })
      .catch(() => {});
  };

  getClassBySchool = (schoolId) => {
    let urlData = {};
    if (schoolId) {
      urlData.school_id = schoolId;
    } else {
      urlData.school_id = this.state.searchFields.school_id;
    }
    this.props.api
      .apiGetClassById(urlData)
      .then((response) => {
        let data = response.data[0].records;
        console.log({ data });

        data = data.sort((a, b) => a.curriculum_level - b.curriculum_level);
        let classField = this.state.fields.find(
          (o) => o.name == "curriculum_id"
        );
        console.log({ classField });

        classField.options = [
          { key: "", label: "All" },
          ...data?.options("curriculum_id", "curriculum_name"),
        ];
        // if (
        //   ["SUPER_ADMIN"].includes(localStorage.getItem("currentAdminRole"))
        // ) {
        //   let schoolNames = this.state.fields.find(
        //     (o) => o.name == "school_id"
        //   );
        //   schoolNames.type = "text";
        //   schoolNames.readOnly = true;
        //   schoolNames.defaultValue = JSON.parse(
        //     localStorage.getItem("profile-data")
        //   )?.school_name;
        // }
        this.setState({
          ...this.state.fields,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loader: false,
        });
      });
  };

  getSectionByClassSchool = (sectionData) => {
    console.log({ sectionData });

    let section = this.state.fields.find((o) => o.name == "section");
    section.options = [
      { key: "", label: "All" },
      ...sectionData?.options("section_id", "name"),
    ];
    this.setState({
      ...this.state.fields,
    });
  };

  handleSchoolClassModuleChange(e, id) {
    console.log({ id });

    switch (id) {
      case "school_id":
        this.setState(
          {
            ...this.state.fields,
            searchFields: {
              ...this.state.searchFields,
              school_id: e[0]?.school_id,
            },
          },
          () => {
            this.fetchMonthlyEventProgress();
            e[0]?.school_id && this.getClassBySchool(e[0]?.school_id);
          }
        );
        break;
      case "curriculum_id":
        this.setState(
          {
            ...this.state.fields,
            searchFields: {
              ...this.state.searchFields,
              curriculum_id: e[0]?.curriculum_id,
            },
          },
          () => {
            this.fetchMonthlyEventProgress();
            e[0]?.curriculum_id && this.getSectionByClassSchool(e[0].section);
          }
        );
        break;

      case "section":
        this.setState(
          {
            ...this.state.fields,
            searchFields: {
              ...this.state.searchFields,
              section: e[0]?.section_id,
            },
          },
          () => {
            this.fetchMonthlyEventProgress();
          }
        );
        break;

      default:
        break;
    }
  }

  onSearch(data) {
    console.log("onSearch data on PARENT: ", data);
    this.setState(
      {
        eventSearch: data,
      },
      () => {
        if (localStorage.getItem("currentAdminRole") === "SUPER_ADMIN") {
          this.fetchEventDashboardStats(data);
        }

        if (
          ["SCHOOL_ADMIN", "SCHOOL_COORDINATOR"].includes(
            localStorage.getItem("currentAdminRole")
          )
        ) {
          this.fetchEventDashboardStats(data);
        }
      }
    );
  }

  handleReportDownload(e, type) {
    e.preventDefault();
    e.stopPropagation();
    console.log({ type });
    let schoolIdVal;
    if (localStorage.getItem("currentAdminRole") === "SCHOOL_COORDINATOR") {
      schoolIdVal = localStorage.getItem("school_id");
    }

    if (localStorage.getItem("currentAdminRole") === "SUPER_ADMIN") {
      schoolIdVal = document.querySelector('.reportsearch [name="school_id"]')
        .dataset.invalue;
    }
    if (localStorage.getItem("currentAdminRole") === "SCHOOL_ADMIN") {
      schoolIdVal = localStorage.getItem("school_id");
    }
    let inputStartDateVal = document.querySelector(
      '.reportsearch [name="start_date"]'
    ).value;
    let inputEndDateVal = document.querySelector(
      '.reportsearch [name="end_date"]'
    ).value;

    let curriculumId = document.querySelector(
      ".reportsearch [name='appinput-curriculum_id'].form-group"
    )?.vnode?.refs?.select2?.state?.values[0]?.key;

    let sectionId = document.querySelector(
      ".reportsearch [name='appinput-section_id'].form-group"
    )?.vnode?.refs?.select2?.state?.values[0]?.key;

    let topicId = document.querySelector(
      ".reportsearch [name='appinput-topic'].form-group"
    )?.vnode?.refs?.select2?.state?.values[0]?.key;

    let eventStatus = document.querySelector(
      ".reportsearch [name='appinput-event_status'].form-group"
    )?.vnode?.refs?.select2?.state?.values[0]?.key;

    console.log({
      schoolIdVal,
      inputStartDateVal,
      inputEndDateVal,
    });

    let payload = {
      school_id: schoolIdVal || null,
      ...(curriculumId
        ? {
            curriculum_id: curriculumId,
          }
        : {}),
      ...(sectionId
        ? {
            section_id: sectionId,
          }
        : {}),
      ...(topicId
        ? {
            topic: topicId,
          }
        : {}),
      ...(eventStatus
        ? {
            event_status: eventStatus,
          }
        : {}),
      ...(inputStartDateVal === "" || inputStartDateVal === null
        ? {}
        : {
            start_date: new Date(inputStartDateVal).toISOString(),
          }),
      ...(inputEndDateVal === "" || inputEndDateVal === null
        ? {}
        : {
            end_date: new Date(inputEndDateVal).toISOString(),
          }),
    };

    console.log({ payload });
    this.setState({
      loader: true,
    });
    if (type === "pdf") {
      if (payload?.school_id === null) {
        this.setState({
          loader: false,
        });
        alert("Please select School");
        return;
      } else {
        payload = {
          ...payload,
          school_id: schoolIdVal,
        };
      }
      this.props.api
        .apiGetEventReportPdf(payload)
        .then(async (res) => {
          if (res) {
            this.setState({
              loader: false,
            });

            let apiRes = await res;
            let blob = new Blob([apiRes], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "event-report-pdf");
            link.click();
            // console.log({ apiRes, blob, link });

            success("Downloaded Successfully");
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
        });
    }
    if (type === "excel") {
      let excelPayload = {};
      if (payload?.school_id === null) {
        this.setState({
          loader: false,
        });
        alert("Please select School");
        return;
      } else {
        excelPayload = {
          school_id: schoolIdVal,
          ...(curriculumId
            ? {
                curriculum_id: curriculumId,
              }
            : {}),
          ...(sectionId
            ? {
                section_id: sectionId,
              }
            : {}),
          ...(topicId
            ? {
                topic: topicId,
              }
            : {}),
          ...(eventStatus
            ? {
                event_status: eventStatus,
              }
            : {}),
          ...(inputStartDateVal === "" || inputStartDateVal === null
            ? {}
            : {
                start_date: new Date(inputStartDateVal).toISOString(),
              }),
          ...(inputEndDateVal === "" || inputEndDateVal === null
            ? {}
            : {
                end_date: new Date(inputEndDateVal).toISOString(),
              }),
        };
      }
      // console.log({ excelPayload });
      this.props.api
        .apiGetEventReportExcel(excelPayload)
        .then(async (res) => {
          if (res) {
            this.setState({
              loader: false,
            });

            let apiRes = await res;
            let blob = new Blob([apiRes], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "event-report-excel");
            link.click();
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
        });
    }
  }

  handleReportTypeSelect(e, type) {
    this.setState({
      graphReportType: type,
    });
    if (type === "WEEKLY") {
      document
        .querySelector('.graph_chart [name="appinput-daterange"]')
        .parentElement.classList.remove("d-none");
      // document.querySelector('.graph_chart [name="daterange"]').value = "";
    } else {
      document
        .querySelector('.graph_chart [name="appinput-daterange"]')
        .parentElement.classList.add("d-none");
    }
  }

  handleSelect(ranges) {
    console.log(ranges);
    this.setState({ selectionRange: ranges.selection });
  }

  toUTCISOStringMidnight(date) {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    ).toISOString();
  }

  clearGraphFields = () => {
    // clearing DOM input values here

    this.refs.form.form.current.reset();
    this.setState({
      fields: this.state.fields.map((field) => ({
        ...field,
        value: "",
        defaultValue: "",
      })),
      searchFields: {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      },
    });
    let data = this.refs.form.form.current.getData();
    data = Object.filter(data, (val) => "");
    document.querySelector('[name="appinput-daterange"] .clear-button').click();
    document.querySelector("#monthlyTabBtn").click();
    console.log({ data }, Object.keys(data)?.length);
    this.fetchMonthlyEventProgress(
      {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      },
      true
    );
  };

  render() {
    let { reportColumns } = this;
    let {
      dashboardData,
      invoiceData,
      fields,
      reportData,
      reportRowcount,
      schooldata,
      loader,
    } = this.state;
    return (
      <>
        <Helmet>
          <title>Dashboard - CognoSpace</title>
          <meta name="description" content="Dashboard" />
        </Helmet>
        {/* Page Content */}
        <div className="content container-fluid">
          {loader && (
            <div className="loader-container">
              <div className="spinner"></div>
            </div>
          )}
          {/* Page Header */}
          <div className="page-header">
            {localStorage.getItem("currentAdminRole") ===
            "SCHOOL_COORDINATOR" ? (
              <>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-lg-1 col-sm-1">
                        <img
                          src={window.store.getState().root.schoolLogo}
                          width="76px"
                          height="66px"
                          alt="Image"
                        />
                      </div>
                      <div className="col dashboard-title">
                        <h3 className="page-title">{`Welcome to ${localStorage.getItem(
                          "school_name"
                        )} Dashboard`}</h3>
                        <ul className="breadcrumb">
                          <li className="breadcrumb-item active">Home</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : localStorage.getItem("currentAdminRole") === "SCHOOL_ADMIN" ? (
              <div className="row">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-lg-1 col-sm-1">
                      <img
                        src={window.store.getState().root.schoolLogo}
                        width="76px"
                        height="66px"
                        alt="Image"
                      />
                    </div>
                    <div className="col dashboard-title">
                      <h3 className="page-title">{`${
                        window.store.getState().root.schoolName
                      }`}</h3>
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item active">Welcome</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : localStorage.getItem("currentAdminRole") === "SUPER_ADMIN" ? (
              <>
                <div className="row">
                  <div className="col-sm-12">
                    <h3 className="page-title">Dashboard</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item active">Dashboard</li>
                    </ul>
                  </div>
                </div>
                <div className="row">
                  {dashboardData?.map((o, i) => (
                    <div
                      className="col-md-6 col-sm-6 col-lg-4 col-xl-3"
                      key={i}
                    >
                      <div
                        className="card dash-widget cursor-pointer"
                        // onClick={() => this.cardAction(o, i)}
                      >
                        <div className="card-body flex justify-content-start align-items-center">
                          <span className="dash-widget-icon">
                            <img
                              src={o.icon}
                              alt="img"
                              width="40px"
                              height="40px"
                            />
                            <div class="vr text-white ms-3"></div>
                          </span>
                          <div className="dash-widget-info">
                            <h3>{o.count}</h3>
                            <span className="formName">{o.formName}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Dashboard</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">Dashboard</li>
                  </ul>
                </div>
              </div>
            )}
          </div>

          <div
            className={`d-flex mb-3 ${
              ["SUPER_ADMIN"].includes(localStorage.getItem("currentAdminRole"))
                ? "justify-content-between"
                : "justify-content-end"
            }`}
          >
            {["SUPER_ADMIN"].includes(
              localStorage.getItem("currentAdminRole")
            ) ? (
              <div className="sub-header">Report</div>
            ) : (
              ""
            )}
            {["SUPER_ADMIN", "SCHOOL_ADMIN", "SCHOOL_COORDINATOR"].includes(
              localStorage.getItem("currentAdminRole")
            ) ? (
              // <a href="#" className="download_link">
              //   <i className="fa fa-download me-2"></i>
              //   <span>Report Download</span>
              // </a>

              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  Report Download
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={(e) => this.handleReportDownload(e, "pdf")}
                  >
                    Download PDF
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#"
                    onClick={(e) => this.handleReportDownload(e, "excel")}
                  >
                    Download Excel
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : null}
          </div>

          {["SUPER_ADMIN", "SCHOOL_ADMIN", "SCHOOL_COORDINATOR"].includes(
            localStorage.getItem("currentAdminRole")
          ) ? (
            <>
              <ReportSearch
                schooldata={schooldata}
                onSearch={(...arg) => this.onSearch(...arg)}
              />
              <AppTable
                data={reportData}
                columns={reportColumns}
                onNext={() => this.onNext()}
                onPrev={() => this.onPrev()}
                onChange={(...arg) => this.onPageChange(...arg)}
                total={reportRowcount}
                reorder={true}
                viewable={false}
                editable={false}
                deletable={false}
                targetType="tap"
                isresponsive={true}
              ></AppTable>
            </>
          ) : (
            <>
              <img
                src={imagepaths?.dashboardIllustration}
                className="img-fluid dash_img"
                alt="image"
              />
            </>
          )}

          {["SUPER_ADMIN"].includes(
            localStorage.getItem("currentAdminRole")
          ) && (
            <>
              <div className="sub-header mt-4">Monthly Event Progress</div>
              {this.state.series3 && (
                <div className="graph_chart">
                  <div id="chart">
                    <div className="row justify-content-start ml-3">
                      <div className="report_btn_group col-12">
                        <button
                          id="monthlyTabBtn"
                          className={Object.className({
                            "btn me-3": true,
                            "add-btn":
                              this.state.graphReportType === "MONTHLY"
                                ? true
                                : false,
                          })}
                          onClick={(e) =>
                            this.handleReportTypeSelect(e, "MONTHLY")
                          }
                        >
                          Monthly Stats
                        </button>
                        <button
                          className={Object.className({
                            btn: true,
                            "add-btn":
                              this.state.graphReportType === "WEEKLY"
                                ? true
                                : false,
                          })}
                          onClick={(e) =>
                            this.handleReportTypeSelect(e, "WEEKLY")
                          }
                        >
                          Weekly Stats
                        </button>
                      </div>
                      <AppForm className="mb-4" ref="form">
                        <div className="row">
                          {fields.map((field, i) => (
                            <div
                              className={`col-sm-6 col-md-3 col-xl-3 ${
                                field?.outerColclass || ""
                              }`}
                              key={i}
                            >
                              <AppInput {...field}></AppInput>
                            </div>
                          ))}
                          <div className="col-12">
                            <span
                              className="item clear-all d-flex align-items-center left-0"
                              onClick={() => this.clearGraphFields()}
                            >
                              Clear Filter
                            </span>
                          </div>
                        </div>
                      </AppForm>
                    </div>
                    {this.state.series3[0]?.data?.length > 0 ? (
                      <ReactApexChart
                        options={this.state.options3}
                        series={this.state.series3}
                        type="bar"
                        height={350}
                      />
                    ) : (
                      <div className="no_data_dashboard_layout"></div>
                    )}
                  </div>
                  <div id="html-dist"></div>
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default connect(Dashboard);
